//todo : refactoring must have all the ddm helpers imports from this file
import { axiosKeys, businessInfoKeys, commonKeys, policySchemaKeys, storeKeys } from 'ui/data/constants/keys';
import {
  fetchPermissionDetails,
  getDDMLobsToselect,
  getUserList,
  isDDMIntegrationActive,
  onSearchAgencyAgentUWDDM,
  onSearchUnifiedDDM,
} from './helper';
import { callAPI, getStoreState, setStoreState } from '@cogitate/ui-multi-utils';
import nProgress from 'nprogress';
import { alertMsgs } from 'ui/data/constants/messages';
import { toast } from 'react-toastify';

//#endregion LOGIN PAGE

//#region CREATE QUOTE
export const getDDMAgencyOptions = async (role, query, useResponseExpression, brokerCode = '') => {
  try {
    const agencies = await onSearchAgencyAgentUWDDM(role, query, useResponseExpression, brokerCode);
    if (agencies?.[role]?.length > 0) {
      return agencies[role];
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    toast.error(error.message);
    throw error;
  }
};

export const onFetchDDM = async (data, query, policyData) => {
  try {
    let options = [];
    switch (data) {
      case policySchemaKeys.AgencyDetails:
      case businessInfoKeys.SelectRetailAgency:
        options = await getDDMAgencyOptions('Agency', query, true);
        break;

      case policySchemaKeys.AgentDetails:
      case businessInfoKeys.SelectAgent:
        options = await getDDMAgencyOptions('Agent', query, true, policyData?.Agency?.Code);
        break;

      case policySchemaKeys.UnderWriterDetails:
      case businessInfoKeys.SelectUW:
        options = await getDDMAgencyOptions('Underwriter', query, true, policyData?.Agency?.Code);
        break;
      default:
        break;
    }
    setStoreState(storeKeys.PolicyReducer, policyData);
    return options;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const updateOptionDetails = async (key, value, policyData, reset = false) => {
  let options = [];
  switch (key) {
    case businessInfoKeys.SelectRetailAgency:
    case policySchemaKeys.AgencyDetails:
      if (reset) {
        // Reset condition
        options = [{ key: '', label: 'Select...', value: '' }];
      } else {
        options = policyData?.Agency?.Code
          ? [
              {
                key: policyData?.Agency?.Code,
                label: policyData?.Agency?.Name
                  ? `${policyData?.Agency?.Code} - ${policyData?.Agency?.Name}, ${policyData?.Agency?.Address?.City}, ${policyData?.Agency?.Address?.State}`
                  : 'Type...',
                value: policyData?.Agency?.Code,
              },
            ]
          : [];
      }
      break;
    case businessInfoKeys.SelectAgent:
    case policySchemaKeys.AgentDetails:
      if (reset) {
        // Reset condition
        options = [{ key: '', label: 'Select...', value: '' }];
      } else {
        options = policyData?.Agent?.Code
          ? [
              {
                key: policyData?.Agent?.Code,
                label: policyData?.Agent?.Name
                  ? `${policyData?.Agent?.Name} - ${policyData?.Agent?.Details?.Contact?.EmailId}`
                  : 'Type...',
                value: policyData?.Agent?.Code,
              },
            ]
          : [];
      }
      break;
    case businessInfoKeys.SelectUW:
    case policySchemaKeys.UnderWriterDetails:
      if (reset) {
        options = [{ key: '', label: 'Select...', value: '' }];
      } else {
        options = [
          {
            key: policyData?.UnderWriter?.UserLogin,
            label: policyData?.UnderWriter?.Name ? policyData?.UnderWriter?.Name : 'Select...',
            value: policyData?.UnderWriter?.UserLogin,
          },
        ];
      }
      break;
  }
  return options;
};

//#endregion CREATE QUOTE

//#region  QUOTE ACTION
export const onSchemaChangeForAgencyDDM = (changedModel) => {
  const masterObject = getStoreState(storeKeys.MasterReducer);
  if (!isDDMIntegrationActive()) {
    changedModel.Agency = masterObject.agencies.find((x) => x.Code === changedModel.Agency.Code);
  }

  return changedModel;
};

export const onSchemaChangeForAgentDDM = (changedModel) => {
  const masterObject = getStoreState(storeKeys.MasterReducer);
  const _role = getStoreState(storeKeys.LoggedInUserReducer).decodedJWT.role;
  if (!isDDMIntegrationActive()) {
    changedModel.Agent = masterObject.agents.find((x) => x.Code === changedModel.Agent.Code);
  } else {
    //if (role === commonKeys.RoleAgent) {
    setPermissionState(changedModel.Agent.Code);
  }

  return changedModel;
};

export const onSchemaChangeForUWDDM = (changedModel) => {
  const masterObject = getStoreState(storeKeys.MasterReducer);
  if (!isDDMIntegrationActive()) {
    changedModel.UnderWriter = masterObject.underwriter.find((x) => x.Code === changedModel.UnderWriter.Code);
  }

  return changedModel;
};

export const setSchemaOnChangeAgentDetailsDDM = (c, value) => {
  const masterObject = getStoreState(storeKeys.MasterReducer);
  if (!isDDMIntegrationActive()) {
    const option = masterObject?.agents
      .filter((a) => a.Reference.includes(value))
      .map((a) => {
        return { key: a.Code, label: a.Name, value: a.Code };
      });
    c.options = option;
  }

  return c;
};

export const filterLOBsList = (landingSchema, setSchema, selectedStateCode) => {
  try {
    nProgress.start();
    const permissionsDetails = fetchPermissionDetails();
    const findAuthorizedLobs = [
      ...new Set(
        permissionsDetails
          .filter((state) => {
            const isActive = state?.IsActive;
            // const validateEffectiveDate = state?.EffectiveDate !== "" ? moment(state?.EffectiveDate) <= moment(moment().format("YYYY-MM-DD")) : true;
            // const validateExpiryDate = state?.ExpiryDate !== "" ? moment(state?.ExpiryDate) >= moment(moment().format("YYYY-MM-DD")) : true;
            // if (isActive && state.StateCode === selectedStateCode && validateEffectiveDate && validateExpiryDate) {
            if (isActive && state.StateCode === selectedStateCode) {
              return state;
            }
          })
          .map((el) => {
            return el.LobCode;
          })
      ),
    ];
    const loblist = findAuthorizedLobs?.length ? getStoreState(storeKeys.ApplicationReducer)?.LobsToSelect : [];
    const updatedSchema = landingSchema[0].map((item) => ({
      ...item,
      controls: item.controls.map((control) =>
        control.key === policySchemaKeys.LineOfBusiness
          ? {
              ...control,
              options: loblist?.filter((data) => findAuthorizedLobs?.includes(data.key)),
            }
          : control
      ),
    }));

    setSchema((prevState) => [updatedSchema, prevState[1]]);

    return true;
  } catch (error) {
    console.error('Utilities.Helpers.FilterLOBsList:: ', error);
    toast.error(alertMsgs.ToasterMsg.SomethingWentWrong);
  } finally {
    nProgress.done();
  }
};

export const permissionAPICallDDM = async (filterData) => {
  try {
    nProgress.start();
    const { Username } = filterData;
    const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
    const headers = {
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_ADAPTIVE_SUBSCRIPTION_KEY.toLocaleLowerCase(),
      Authorization: `Bearer ${loggedInUser.encodedJWT}`,
      Accept: 'application/json, text/plain, */*',
    };
    const requestURL = `${process.env.NEXT_PUBLIC_ADAPTIVE_API_BASE_URL}${process.env.NEXT_PUBLIC_CTS_PERMISSION_URL}`;
    const filterDatatemp = {
      Username: loggedInUser.decodedJWT.Username,
      Company: '',
      ProfitCenters: '',
      StateCode: '',
      CarrierCode: '',
      LobCode: '',
    };
    const payload = {
      filter: {
        ...filterDatatemp,
        ...filterData,
        Username: loggedInUser.decodedJWT.role === commonKeys.RoleAgent ? loggedInUser.decodedJWT.Username : Username,
      },
      UserId: loggedInUser.decodedJWT.UserId,
      Role: 'Agent',
      ProductName: process.env.NEXT_PUBLIC_CLIENT,
    };

    // Execute the API call using the common callAPI function.
    const apiResponse = await callAPI(axiosKeys.PostAction, requestURL, payload, headers);

    nProgress.done();

    return apiResponse.Output;
  } catch (error) {
    console.error('Error in simpleAPICall', error);
    nProgress.done();
    toast.error(alertMsgs.ToasterMsg.SomethingWentWrong);
    throw error;
  }
};

export const handleAgentLOBsAccPermission = (changedModel, landingSchema, setSchema) => {
  const permissions = getStoreState(storeKeys.ApplicationReducer);
  const userPermissions = permissions?.DDM?.UserDDMPermission;
  if (changedModel.Risks.Properties[0].Address.State !== '' && userPermissions?.length > 0) {
    const locationStateCode = changedModel.Risks.Properties[0].Address.StateCode;
    filterLOBsList(landingSchema, setSchema, locationStateCode);
  }
  return changedModel;
};

export const setPermissionState = async (agent) => {
  const ApplicationReducer = getStoreState(storeKeys.ApplicationReducer);
  //const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer).decodedJWT.Username;
  const permissionsDetails = await permissionAPICallDDM({
    Username: agent,
    //Username: 'Agent_User',
  });

  if (!permissionsDetails) {
    return;
  }
  setStoreState(storeKeys.ApplicationReducer, {
    ...ApplicationReducer,

    DDM: {
      ...ApplicationReducer.DDM,
      UserDDMPermission: Array.isArray(permissionsDetails) ? [...permissionsDetails] : [{ ...permissionsDetails }],
    },
  });
};

export const handleSubmitQuoteLanding = async (model) => {
  const changedModel = structuredClone(model);
  if (isDDMIntegrationActive()) {
    try {
      const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
      const isUnderWriter = loggedInUser.decodedJWT.role.toLowerCase() === 'underwriter';
      const agencyDetails = await onSearchUnifiedDDM('Agency', {
        BrokerCode: changedModel.Agency.Code,
      });
      changedModel.Agency = JSON.parse(JSON.stringify(agencyDetails.Agency));

      const agentDetails = await onSearchUnifiedDDM('Agent', {
        UserId: changedModel.Agent.Code,
      });
      //console.log("AGENT DET---->", agentDetails)
      changedModel.Agent = JSON.parse(JSON.stringify(agentDetails.Agent));

      if (isUnderWriter) {
        const underwriterDetails = await onSearchUnifiedDDM('Underwriter', {
          UserLogin: changedModel.UnderWriter.Code,
        });
        changedModel.UnderWriter = JSON.parse(JSON.stringify(underwriterDetails.UnderWriter));
      }
      setStoreState(storeKeys.PolicyReducer, changedModel);
      return changedModel;
    } catch (error) {
      throw new Error(error);
    }
  }

  return changedModel;
};

//#endregion  QUOTE ACTION
export const updateLobsToSelect = () => {
  const lobsToSelect = getDDMLobsToselect();

  if (lobsToSelect) {
    const ApplicationReducer = getStoreState(storeKeys.ApplicationReducer);
    setStoreState(storeKeys.ApplicationReducer, {
      ...ApplicationReducer,
      LobsToSelect: [...lobsToSelect],
    });
  }
};

//#region COMMUNICATIONHUB
export const combineOutputArrays = (response) => {
  const { Underwriter, Agent, Agency } = response;
  return [...(Underwriter || []), ...(Agent || []), ...(Agency || [])];
};

export const GetAlltheUserDDM = async (policyData, searchText) => {
  const users = await onSearchAgencyAgentUWDDM(
    ['Agent', 'Underwriter'],
    searchText,
    true,
    policyData.Agency.Code,
    '{\r\n  "Agency": Agency[].{\r\n    "name": DBAName,\r\n    "userId": BrokerCode,\r\n    "email": Communications[Type = "Email"].Value\r\n  },\r\n  "Agent": Agent[].{\r\n    "name": Name,\r\n    "userId": Code ? Code : UserLogin,\r\n    "email": Email ? Email : Communications[Type = "Email"].Value\r\n  },\r\n  "Underwriter": Underwriter[].{\r\n    "name": Name,\r\n    "userId": Code ? Code : UserLogin,\r\n    "email": Email ? Email : Communications[Type = "Email"].Value\r\n  }\r\n}\r\n'
  );

  return combineOutputArrays(users);
};

export const handleCommunciationHubUsers = async (policyData, searchText = '') => {
  if (isDDMIntegrationActive()) {
    const users = await GetAlltheUserDDM(policyData, searchText);
    return users.map((user) => ({
      key: user.userId,
      label: user.name,
      value: user.email,
    }));
  } else {
    const masterReducer = getStoreState(storeKeys.MasterReducer);
    const userList = [...masterReducer.agents, ...masterReducer.underwriter, ...masterReducer.agencies];
    const temp = getUserList(userList, masterReducer.underwriter?.length);
    return temp;
  }
};

//#endregion COMMUNCICATIONHUB
